class AjaxCart extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    this.init();

    /**
     * @type {FocusTrap}
     */
    this.trap = focusTrap.createFocusTrap(this, {
      // a11y: focus a concrete, stable control inside the cart
      initialFocus: () =>
        this.querySelector("#cart-drawer-close-x") ||
        this.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ) ||
        this,
      fallbackFocus: () => this.querySelector("#cart-drawer-close-x") || this,
      escapeDeactivates: true,
      // Allow outside clicks so overlay clicks can close the cart
      allowOutsideClick: true,
      clickOutsideDeactivates: false,
      preventScroll: true,
    });

    this.emptyCartMessage = this.dataset.emptyCartMessage;

    messenger.listen(
      messenger.topics.OPEN_CART,
      async () => {
        // console.log('ajax-cart receiving open cart');
        this.openCart();
      },
      "AjaxCart"
    );

    messenger.listen(
      messenger.topics.BUILD_CART,
      /** @param {Cart} cart */
      async (cart) => {
        // console.log('ajax-cart receiving building cart', cart);
        await this.buildCart(cart);
      },
      "AjaxCart"
    );

    messenger.listen(
      messenger.topics.UPDATE_TOTAL_PRICE,
      /** @param {Cart} cart */
      async (cart) => {
        // console.log(
        //   'ajax-cart receiving update total price',
        //   cart.total_price
        // );
        this.updateTotalPrice(cart);
      },
      "AjaxCart"
    );

    window.addEventListener("resize", this.resizeFooter.bind(this));

    // close on outside click
    window.addEventListener(
      "click",
      /** @param {MouseEvent} event */ (event) => {
        if (!this.isCartDrawerOpen()) {
          return;
        }
        if (
          !event.target.closest('a[id="cart-icon"]') &&
          !event.target.closest("ajax-cart")
        ) {
          this.closeCart();
        }
      }
    );
  }

  async connectedCallback() {
    this.closeX = this.querySelector(".drawer__close-button");
    if (!this.closeX) {
      console.log("no close button found");
      return;
    }
    this.closeX.addEventListener("click", (event) => {
      event.stopPropagation();
      this.closeCart();
    });

    this.continueScrolling = this.querySelector(
      ".ajaxcart__continue_scrolling"
    );
    if (this.continueScrolling) {
      this.continueScrolling.addEventListener(
        "click",
        /** @param {Event} event */ (event) => {
          event.preventDefault();
          this.scrollCart();
        }
      );
    }

    this.continueShoppingButton = this.querySelector(
      "#continue-shopping-button"
    );
    if (this.continueShoppingButton) {
      this.continueShoppingButton.addEventListener("click", () => {
        this.closeCart();
      });
    }
    this.innerDrawer = this.querySelector(".cart-drawer__inner");
    if (this.innerDrawer) {
      this.innerDrawer.addEventListener(
        "scroll",
        this.checkScrollButtonVisibility.bind(this)
      );
    }

    this.cartIcon = document.querySelector("#cart-icon");
    if (!this.cartIcon) {
      return; // Fallback for pages without cart-icon
    }
    this.cartIcon.addEventListener(
      "click",
      this.handleCartIconClick.bind(this)
    );
    this.subtotal = this.querySelector(".ajax__checkout-subtotal");
    this.totalPrice = this.subtotal
      ? this.subtotal.querySelector(".ajaxcart__price")
      : null;
    this.checkoutButton = this.querySelector("#checkout-button");
    if (this.checkoutButton) {
      this.checkoutButton.addEventListener("click", (event) => {
        event.preventDefault();
        store.deleteCartFromSessionStorage();
        window.location.href = "/checkout";
      });
    } else {
      console.error("Failed to find Checkout-button in Ajax-Cart!");
    }

    // this.buildCart();
    try {
      const cart = await store.getCart();
      // console.log('building cart in ajx-cart.js: ', cart);
      knocking.buildCart(cart);
      this.resizeFooter();
      if (this.checkUrlOpenCart()) {
        this.openCart();
      }
      if (!this.isCartDrawerOpen()) {
        this.removeCartOpenHash();
      }
    } catch (error) {
      knocking.buildCart();
      console.log("error getting cart: ", error);
    }

    this.inert = true;
  }

  init() {}

  // services
  async getCart() {
    const cart = await store.getCart();

    return cart;
  }

  // helpers
  removeCartOpenHash() {
    if (location.hash === "#cart-open") {
      history.go(-1);
    }
  }

  checkScrollButtonVisibility() {
    const wrapper = this.querySelector(".ajaxcart__continue_scrolling_wrapper");
    if (!wrapper) {
      console.log("no wrapper found");
      return;
    }
    const cartItems = this.innerDrawer
      ? this.innerDrawer.querySelectorAll("ajax-cart-item")
      : [];
    if (cartItems.length === 0) {
      wrapper.classList.remove("ajaxcart__continue_scrolling_visible");
      return;
    }
    if (wrapper && !this.isInViewport(cartItems[cartItems.length - 1])) {
      wrapper.classList.add("ajaxcart__continue_scrolling_visible");
    } else if (wrapper) {
      wrapper.classList.remove("ajaxcart__continue_scrolling_visible");
    }
  }

  /**
   * @param {Element} element
   * @returns {boolean | null}
   * */
  isInViewport(element) {
    if (!element) {
      console.log("element not found");
      return null;
    }
    const rect = element.getBoundingClientRect();
    // console.log("rect-top: ", rect.top);
    // console.log("rect-left: ", rect.left);
    // console.log("rect-right: ", rect.right);
    // console.log("rect-bottom: ", rect.bottom);
    // console.log("window.innerHeight: ", window.innerHeight);
    // console.log("document.documentElement.clientHeight: ", document.documentElement.clientHeight);
    // console.log("window.innerWidth: ", window.innerWidth);
    // console.log("document.documentElement.clientWidth: ", document.documentElement.clientWidth);

    const isInViewport =
      rect.top >= 0 &&
      // rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight);
    // rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    // console.log("isInViewport: ", isInViewport);
    return isInViewport;
  }

  getFirstInvisibleElement() {
    const cartItems = this.innerDrawer
      ? this.innerDrawer.querySelectorAll("ajax-cart-item")
      : [];
    let visibleItemFound = false;
    for (let i = 0; i < cartItems.length; i++) {
      const item = cartItems[i];
      const isInViewport = this.isInViewport(item);
      if (isInViewport) {
        visibleItemFound = true;
      }
      if (!isInViewport && visibleItemFound) {
        return item;
      }
    }
    return null;
  }

  checkUrlOpenCart() {
    let url = new URL(window.location.href);
    let search = url.search;

    let queryStringFull = search.replace("?", "");
    var queryStringArr = queryStringFull.split("&");

    let openCart;

    for (let i = 0; i < queryStringArr.length; i++) {
      const query = queryStringArr[i];
      if (query.includes("openCart=")) {
        openCart = query.replace("openCart=", "") === "true" ? true : false;
        return !!openCart;
      }
    }
    return false;
  }

  isCartDrawerOpen() {
    return this.classList.contains("cart-drawer-open");
  }

  /**
   * @param {Cart} cart
   * @returns {number | null}
   * */
  getCartTotalPrice(cart) {
    if (!cart) {
      console.error("no cart to diplay total price");
      return null;
    }
    let cartTotalPrice = cart.total_price;
    return cartTotalPrice;
  }

  addOneShotPopStateListener() {
    // console.log("addOneShotPopStateListener");
    if (!this.isCartDrawerOpen()) {
      return;
    }
    window.addEventListener("popstate", this.closeCart.bind(this, true), {
      once: true,
    });
  }

  // DOM manipulation
  scrollCart() {
    const firstInvisibleElement = this.getFirstInvisibleElement();
    if (!firstInvisibleElement) {
      return;
    }
    firstInvisibleElement.scrollIntoView({ behavior: "smooth" });
  }

  cleanUpCart() {
    if (!this.innerDrawer) return;
    while (this.innerDrawer.hasChildNodes()) {
      const lastChild = this.innerDrawer.lastChild;
      if (!lastChild) {
        return;
      }
      this.innerDrawer.removeChild(lastChild);
    }
  }

  /**
   * @param {Cart} cart
   * */
  updateTotalPrice(cart) {
    const cartTotalPrice = this.getCartTotalPrice(cart);
    if (this.totalPrice) {
      this.totalPrice.textContent =
        knocking.formatToDollarCurrencyString(cartTotalPrice);
    }
  }

  showCartEmptyMessage() {
    let messageWrapper = document.createElement("div");
    messageWrapper.className = "ajaxcart__empty";
    let messageMarkup = `
    <div>
    <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" class="icon icon-empty-cart" viewBox="0 0 126 125">
   <defs>
      <style>
      .cls-1,
      .cls-2 {
         fill: none;
      }

      .cls-3 {
         clip-path: url(#clippath);
      }

      </style>
      <clipPath id="clippath">
      <circle class="cls-1" cx="63.5" cy="62.5" r="62.5" />
      </clipPath>
   </defs>
     <g id="Layer_1-2">
       <g>
         <circle id="Ellipse_1374" class="background" cx="62.5" cy="62.5" r="62.5" />
         <g id="Group_10241">
           <path id="Path_2824" class="light-color-stroke" d="M52.68,51.57l3.42,6.09" />
           <path id="Path_2825" class="light-color-stroke" d="M65.92,47.92v10.28" />
           <path id="Path_2826" class="light-color-stroke" d="M76.2,58.21l3.57-3.14" />
           <path id="Path_2827" class="light-color-stroke" d="M39.89,40.03v5.82" />
           <path id="Path_2830" class="light-color-stroke" d="M91.89,35.03v5.82" />
           <path id="Path_2828" class="light-color-stroke" d="M36.98,42.94h5.93" />
           <path id="Path_2829" class="light-color-stroke" d="M88.98,37.94h5.93" />
           <g id="Ellipse_1376">
             <circle class="light-color" cx="58.52" cy="29.5" r="3" />
           </g>
           <g id="Ellipse_1377">
             <circle class="light-color" cx="79.52" cy="39.5" r="2" />
           </g>
           <g id="Ellipse_1378">
             <circle class="light-color" cx="94.52" cy="57.5" r="1" />
           </g>
           <g id="Ellipse_1379">
             <circle class="light-color" cx="40.02" cy="59" r="1.5" />
           </g>
         </g>
         <g class="cls-3">
           <g id="Mask_Group_994">
             <g id="Icon">
               <path class="light-color" d="M43.69,157.14c-4.63,0-8.4-3.77-8.4-8.4s3.77-8.4,8.4-8.4,8.4,3.77,8.4,8.4-3.77,8.4-8.4,8.4Zm44.48-.04c-4.63,0-8.4-3.75-8.4-8.35s3.77-8.35,8.4-8.35,8.4,3.75,8.4,8.35-3.77,8.35-8.4,8.35Zm8.4-22.21H43.69c-2.98,0-5.67-1.53-7.2-4.1-1.54-2.59-1.59-5.72-.15-8.38l6-10.85,.12-.22-.11-.23-16.01-33.77-.14-.29h-8.71v-7.9h13.73l4.04,8.62,.13,.29H101.56c1.41,0,2.68,.73,3.39,1.95,.71,1.22,.73,2.67,.04,3.89l-15.92,28.88c-1.46,2.67-4.28,4.33-7.35,4.33H48.28l-.14,.26-4.89,8.9-.41,.74h53.73v7.9Zm-57.41-48.95l.34,.71,10.54,22.25,.14,.29h31.84l.14-.26,12.28-22.25,.41-.74H39.16Z" />
               </g>
           </g>
         </g>
       </g>
     </g>
   </svg>
   <span>${this.emptyCartMessage}</span>
   <a class="full-unstyled-link button" href="#">See Deals</a>
   </div>
    `;
    messageWrapper.innerHTML = messageMarkup;
    if (this.innerDrawer) {
      this.innerDrawer.appendChild(messageWrapper);
    }
  }

  resizeFooter() {
    let cartFooter = /** @type {HTMLElement | null} */ (
      this.querySelector("#cartDrawerFooter")
    );
    let cartInner = /** @type {HTMLElement | null} */ (
      this.querySelector("#cartDrawerInner")
    );
    if (!cartFooter || !cartInner) return;
    cartFooter.removeAttribute("style");
    cartInner.removeAttribute("style");

    let cartFooterHeight = cartFooter.offsetHeight;
    cartInner.style.bottom = `${cartFooterHeight}px`;
  }

  /**
   * @param {boolean} loading
   * */
  loadingSet(loading) {
    if (loading) {
      this.loading = true;
      this.classList.add("loading");
    } else {
      this.loading = false;
      this.classList.remove("loading");
    }
  }

  // build cart
  /**
   * @param {Cart} cart
   * */
  async buildCart(cart) {
    if (!cart) {
      console.log("no cart provided | bail");
      return;
    }
    if (this.loading === true) {
      console.log("Already loading cart | bail");
      return;
    }
    this.loadingSet(true);
    this.cleanUpCart();
    let itemElements = [];
    // const cart = await this.getCart();
    this.updateTotalPrice(cart);

    if (cart.items.length === 0) {
      this.showCartEmptyMessage();
      this.loadingSet(false);
      console.log("cart is empty");
      messenger.emmit(messenger.topics.UPDATE_CART_BUBBLE, 0);
      this.closeCart();
      messenger.emmit(messenger.topics.CART_READY, cart);
      return;
    }
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      const element = document.createElement("ajax-cart-item");
      element.dataset.item = JSON.stringify(item);
      element.dataset.line = (i + 1).toString();
      element.dataset.productId = item.product_id.toString();
      element.dataset.vendor = item.vendor;
      element.dataset.showShipsBy = this.dataset.showShipsBy;
      element.dataset.isCustomSkuProduct =
        item.properties["_custom-sku-variant"] || false;
      // check for tier discount
      if (item.properties["_tier-discount"]) {
        const tierDiscount = item.properties["_tier-discount"];
        element.dataset.tierDiscount = tierDiscount;
      }
      itemElements.push(element);
    }

    for (let i = 0; i < itemElements.length; i++) {
      if (!this.innerDrawer) return;
      const element = itemElements[i];
      this.innerDrawer.insertAdjacentElement("beforeend", element);
    }

    messenger.emmit(messenger.topics.CART_READY, cart);
    messenger.unlisten(messenger.topics.CART_READY, "KnockingStore");

    this.loadingSet(false);
    if (this.checkUrlOpenCart()) {
      this.openCart();
    }
  }

  // cart events
  async handleCartIconClick() {
    // await this.buildCart();
    this.openCart();
  }

  /**
   * a11y: Hide/unhide background content from assistive tech and interaction
   * @param {boolean} hide
   */
  setBackgroundHidden(hide) {
    const selectors = [
      "#shopify-section-announcement-bar",
      "#shopify-section-header",
      "#shopify-section-subheader",
      "main#MainContent",
      "#shopify-section-footer",
    ];
    selectors.forEach((sel) => {
      const el = document.querySelector(sel);
      if (!el) return;
      if (hide) {
        el.setAttribute("aria-hidden", "true");
        // inert may not be supported in all browsers; set when available
        try {
          el.inert = true;
        } catch (e) {}
      } else {
        el.removeAttribute("aria-hidden");
        try {
          el.inert = false;
        } catch (e) {}
      }
    });
  }

  openCart() {
    console.log("opening cart");
    this.classList.add("cart-drawer-open");
    this.resizeFooter();
    knocking.showBlur();

    // Only add hash on mobile/iOS devices where swipe-back is an issue
    if (
      window.innerWidth <= 768 ||
      /iPad|iPhone|iPod/.test(navigator.userAgent)
    ) {
      history.pushState(null, "", `${location.pathname}#cart-open`);
      this.addOneShotPopStateListener();
    }

    setTimeout(() => {
      this.checkScrollButtonVisibility();
    }, 500);
    knocking.disableScroll();
    // knocking.checkLimits();
    this.inert = false;
    this.removeAttribute("aria-hidden");

    // a11y: hide background from SR and interaction while cart is open
    this.setBackgroundHidden(true);

    // Debug: Check if focus trap is working
    console.log("Activating focus trap for cart drawer");
    this.trap.activate();

    // Ensure all interactive elements within the cart are properly contained
    const interactiveElements = this.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    // Add screen reader announcement for cart opening
    this._announceCartOpen();

    /**
     * @type {HTMLElement | null} drawerTitle
     */
    const drawerTitle = this.querySelector(".cart-drawer__header");
    if (drawerTitle) {
      drawerTitle.focus();
    }
  }

  closeCart(quickhide = false) {
    if (!this.isCartDrawerOpen()) {
      return;
    }

    if (quickhide) {
      // Prevent flicker during back navigation transitions on iOS
      this.classList.add("ajaxcart__quickhide");
      setTimeout(() => {
        this.classList.remove("ajaxcart__quickhide");
      }, 800);
    }

    // 1) Close visually
    this.classList.remove("cart-drawer-open");
    knocking.hideBlur();
    knocking.enableScroll();

    // 2) Re-enable background before moving focus
    this.setBackgroundHidden(false);

    // 3) If focus is inside the cart, move it to a safe element outside
    const isFocusInsideCart = this.contains(document.activeElement);
    const safeFocusTarget =
      document.querySelector("#cart-icon") ||
      document.querySelector(
        '.header__heading-link, .header__heading a, a[href], button, [tabindex]:not([tabindex="-1"])'
      ) ||
      document.body;

    if (isFocusInsideCart && safeFocusTarget) {
      setTimeout(() => {
        try {
          safeFocusTarget.focus({ preventScroll: true });
        } catch (e) {
          safeFocusTarget.focus();
        }
      }, 0);
    }

    // 4) Deactivate focus trap after moving focus
    this.trap.deactivate();

    // 5) Keep cart inert when closed; do not aria-hide focused subtree
    this.inert = true;
    this.removeAttribute("aria-hidden");

    // 6) Clean up URL fragment if present
    this.removeCartOpenHash();
  }

  _announceCartOpen() {
    // Create a screen reader announcement for cart opening
    const announcer = document.createElement("div");
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("aria-atomic", "true");
    announcer.className = "sr-only";
    announcer.style.cssText = `
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    `;

    announcer.textContent =
      "Shopping cart opened. Use Tab to navigate within the cart.";
    document.body.appendChild(announcer);

    // Remove after announcement
    setTimeout(() => {
      announcer.remove();
    }, 1000);
  }
}

customElements.define("ajax-cart", AjaxCart);
